import { useEffect } from 'react';
import { APP_NAME } from '@/constants/app.constants';

export function useDocumentTitle(title: string | undefined): void {
  useEffect(() => {
    if (title === undefined) return;

    const previous = document.title;
    document.title = `${APP_NAME} | ${title}`;

    return () => {
      document.title = previous;
    };
  }, [title]);
}
